import _pt from '../../../node_modules/prop-types/index.js';

var regex = new RegExp(/^-?(((0|[1-9]\d*)(\.\d+)?)|(\.\d+))$/);

var number = function number(validationDefault) {
  return {
    propTypes: {
      numberValidation: _pt.bool.isRequired,
      numberError: _pt.string
    },
    defaultProps: {
      numberValidation: validationDefault
    },
    shouldValidate: function shouldValidate(props) {
      return props.numberValidation === true;
    },
    getErrors: function getErrors(field, value, props) {
      if (value === null || value === undefined || value === "" || typeof value === "number") {
        return [];
      }

      if (typeof value === "string" && !Number.isNaN(value) && regex.test(value)) {
        return [];
      }

      return [props.numberError || "".concat(field, " is not a valid number")];
    }
  };
};

export { number };
